(function () {
  document.querySelectorAll('[data-slideshow]').forEach(function (root) {
    var slides = root.querySelectorAll('[data-slide]'), dots = root.querySelectorAll('[data-dot]'), i = 0, timer;
    var delay = parseInt(root.dataset.autoplay || '0', 10) * 1000;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      restart();
    }
    function restart() { clearInterval(timer); if (delay && slides.length > 1) timer = setInterval(function () { go(i + 1); }, delay); }
    var p = root.querySelector('[data-prev]'), n = root.querySelector('[data-next]');
    p && p.addEventListener('click', function () { go(i - 1); });
    n && n.addEventListener('click', function () { go(i + 1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    restart();
  });

  document.querySelectorAll('[data-slider]').forEach(function (root) {
    var track = root.querySelector('[data-track]');
    function step(dir) { var c = track.firstElementChild; track.scrollBy({ left: dir * (c ? c.offsetWidth + 16 : 300), behavior: 'smooth' }); }
    root.querySelector('[data-prev]').addEventListener('click', function () { step(-1); });
    root.querySelector('[data-next]').addEventListener('click', function () { step(1); });
  });

  document.addEventListener('click', function (e) {
    var w = e.target.closest('[data-wish]'); if (w) w.classList.toggle('is-on');
    var drawer = document.querySelector('[data-drawer]');
    if (e.target.closest('[data-drawer-open]')) drawer.classList.add('is-open');
    if (e.target.closest('[data-drawer-close]')) drawer.classList.remove('is-open');
  });

  // Búsqueda desplegable del encabezado
  var headerSearch = document.querySelector('[data-header-search]');
  var searchToggle = document.querySelector('[data-search-open]');
  var searchInput = headerSearch ? headerSearch.querySelector('[data-search-input]') : null;
  var closeSearch = function (focusToggle) {
    if (!headerSearch || !headerSearch.classList.contains('is-open')) return;
    headerSearch.classList.remove('is-open');
    headerSearch.setAttribute('aria-hidden', 'true');
    if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
    if (focusToggle && searchToggle) searchToggle.focus();
  };
  var openSearch = function () {
    if (!headerSearch) return;
    headerSearch.classList.add('is-open');
    headerSearch.setAttribute('aria-hidden', 'false');
    if (searchToggle) searchToggle.setAttribute('aria-expanded', 'true');
    if (searchInput) setTimeout(function () { searchInput.focus(); }, 30);
  };
  if (headerSearch && searchToggle) {
    searchToggle.addEventListener('click', function (e) {
      e.preventDefault();
      if (headerSearch.classList.contains('is-open')) closeSearch(true);
      else openSearch();
    });
    headerSearch.querySelectorAll('[data-search-close]').forEach(function (button) {
      button.addEventListener('click', function () { closeSearch(true); });
    });
    document.addEventListener('click', function (e) {
      if (!headerSearch.classList.contains('is-open')) return;
      if (headerSearch.contains(e.target) || searchToggle.contains(e.target)) return;
      closeSearch(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSearch(true);
    });
  }

  // Mega menú: permanece abierto al pasar del enlace al panel
  var megaItems = document.querySelectorAll('[data-mega]');
  megaItems.forEach(function (item) {
    var trigger = item.querySelector('.nav-item__trigger');
    var panel = item.querySelector('.mega');
    if (!trigger) return;
    var closeTimer;
    var setExpanded = function (open) {
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    var openMenu = function () {
      clearTimeout(closeTimer);
      megaItems.forEach(function (other) {
        if (other === item) return;
        other.classList.remove('is-open');
        var otherTrigger = other.querySelector('.nav-item__trigger');
        if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
      });
      item.classList.add('is-open');
      setExpanded(true);
      closeSearch(false);
    };
    var closeMenu = function (delay) {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        item.classList.remove('is-open');
        setExpanded(false);
      }, delay === undefined ? 180 : delay);
    };
    item.addEventListener('mouseenter', openMenu);
    item.addEventListener('mouseleave', function () { closeMenu(180); });
    item.addEventListener('focusin', openMenu);
    item.addEventListener('focusout', function (e) {
      if (e.relatedTarget && item.contains(e.relatedTarget)) return;
      closeMenu(120);
    });
    trigger.addEventListener('focus', openMenu);
    if (panel) {
      panel.addEventListener('mouseenter', openMenu);
      panel.addEventListener('mouseleave', function () { closeMenu(180); });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-mega]').forEach(function (item) {
      item.classList.remove('is-open');
      var trigger = item.querySelector('.nav-item__trigger');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
    if (document.activeElement && document.activeElement.closest('[data-mega]')) document.activeElement.blur();
    var drawer = document.querySelector('[data-drawer]');
    if (drawer) drawer.classList.remove('is-open');
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-quick-add]'); if (!form) return;
    e.preventDefault();
    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function () { return fetch('/cart.js'); }).then(function (r) { return r.json(); })
      .then(function (cart) { document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = false; }); });
  });

  // Popup de bienvenida: se muestra una sola vez por visitante
  var popup = document.querySelector('[data-popup]');
  if (popup) {
    var KEY = 'ah_welcome_seen', test = popup.dataset.test === '1';
    var seen = function () {
      try { if (localStorage.getItem(KEY)) return true; } catch (e) {}
      return document.cookie.indexOf(KEY + '=1') > -1;
    };
    var markSeen = function () {
      try { localStorage.setItem(KEY, '1'); } catch (e) {}
      document.cookie = KEY + '=1; path=/; max-age=31536000; SameSite=Lax';
    };
    var open = function () { popup.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; if (!test) markSeen(); };
    var close = function () { popup.classList.remove('is-open'); document.documentElement.style.overflow = ''; if (!test) markSeen(); };
    if (popup.querySelector('[data-popup-success]')) open();
    else if (test || !seen()) { if (!test) markSeen(); setTimeout(open, (parseInt(popup.dataset.delay, 10) || 0) * 1000); }
    popup.querySelectorAll('[data-popup-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    var pf = popup.querySelector('form'); pf && pf.addEventListener('submit', markSeen);
  }

  // Galería de producto
  var main = document.querySelector('[data-pdp] [data-main]');
  document.querySelectorAll('[data-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      document.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.toggle('is-active', x === t); });
      if (main) { main.removeAttribute('srcset'); main.src = t.dataset.src; }
    });
  });

  // Variantes (tamaños / decants)
  document.querySelectorAll('[data-variant]').forEach(function (r) {
    r.addEventListener('change', function () {
      var q = function (s) { return document.querySelector(s); };
      q('[data-price]').textContent = r.dataset.price;
      var c = q('[data-compare]'); if (c) { c.textContent = r.dataset.compare; c.hidden = !r.dataset.compare; }
      var pct = q('[data-pct]'); if (pct) pct.hidden = !r.dataset.compare;
      var l = q('[data-size-label]'); if (l) l.textContent = r.dataset.title;
      if (r.dataset.image && main) { main.removeAttribute('srcset'); main.src = r.dataset.image; }
      var url = new URL(location.href); url.searchParams.set('variant', r.value); history.replaceState(null, '', url);
    });
  });

  // Cantidad
  document.querySelectorAll('[data-qty]').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelectorAll('[data-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        input.value = Math.max(parseInt(input.min || '0', 10), (parseInt(input.value, 10) || 0) + parseInt(b.dataset.step, 10));
        if (input.hasAttribute('data-autosubmit')) input.form.submit();
      });
    });
    if (input.hasAttribute('data-autosubmit')) input.addEventListener('change', function () { input.form.submit(); });
  });

  // Colección: filtros, orden y vista
  var ff = document.querySelector('[data-filter-form]');
  if (ff) {
    ff.addEventListener('change', function (e) {
      if (e.target.name === 'sort_by' || e.target.type === 'checkbox') ff.submit();
    });
    ff.querySelectorAll('.price-range input').forEach(function (i) { i.addEventListener('blur', function () { ff.submit(); }); });
    var grid = ff.querySelector('[data-grid]');
    ff.querySelectorAll('[data-view]').forEach(function (b) {
      b.addEventListener('click', function () {
        ff.querySelectorAll('[data-view]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
        grid.classList.toggle('is-4', b.dataset.view === '4');
      });
    });
    var ft = ff.querySelector('[data-filters-toggle]');
    ft && ft.addEventListener('click', function () { ff.querySelector('[data-filters]').classList.toggle('is-open'); });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-acc]'); if (!b) return;
    var open = b.getAttribute('aria-expanded') === 'true';
    b.setAttribute('aria-expanded', open ? 'false' : 'true');
    b.parentNode.classList.toggle('is-open', !open);
  });

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && Shopify.designMode;
  var groups = [
    ['.benefit', 90], ['.cat', 80], ['.moment', 80], ['.family', 60], ['.card', 70],
    ['.section-head', 0], ['.story__copy', 0], ['.story__media', 120], ['.moments__title', 0]
  ];
  groups.forEach(function (g) {
    document.querySelectorAll(g[0]).forEach(function (el, n) {
      if (el.closest('.hero, .welcome, .drawer') || el.hasAttribute('data-reveal')) return;
      el.setAttribute('data-reveal', '');
      if (g[1]) el.style.setProperty('--rd', ((n % 6) * g[1]) + 'ms');
    });
  });
  var rev = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && !reduce && !designMode) {
    document.documentElement.classList.add('js-reveal');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    rev.forEach(function (r) { io.observe(r); });
  } else rev.forEach(function (r) { r.classList.add('is-in'); });
})();
